import { FormControlLabel, Switch } from '@mui/material';
import React, { useState } from 'react'

const ToggleSwitch = () => {
    const [disableActivity, setDisableActivity] = useState(false);
    return (
        <FormControlLabel
            control={
                <Switch
                    checked={disableActivity}
                    onChange={() => setDisableActivity(!disableActivity)}
                    color="primary"
                    sx={{
                        width: 40,
                        height: 25,
                        padding: 0,
                        '& .MuiSwitch-switchBase': {
                            padding: 0.5,
                            '&.Mui-checked': {
                                transform: 'translateX(16px)',
                                color: '#fff',
                                '& + .MuiSwitch-track': {
                                    backgroundColor: '#E0EEFE',
                                    opacity: 1,
                                    border: '1px solid #0076FE1F',

                                },
                                '& .MuiSwitch-thumb': {
                                    backgroundColor: '#0076FE',
                                }
                            },
                        },
                        '& .MuiSwitch-thumb': {
                            width: 13,
                            height: 13,
                            boxShadow: ' 0 1px 1px #00000040',
                            margin: '2px auto 0',
                        },
                        '& .MuiSwitch-track': {
                            borderRadius: '20px',
                            backgroundColor: '#E5E8EB',
                            opacity: 1,
                            border: '1px solid #D0D5DD',
                        },
                    }}
                />
            }
        />
    )
}

export default ToggleSwitch
